<template>
  <div id="app">
    <navbar :fixed="navbarFixed">test</navbar>
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<style lang="scss">
  @import './styles/main.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
  @import '../node_modules/progress-tracker/app/styles/progress-tracker.scss';
</style>

<script>
import NavBar from '@/components/NavBar.vue'
import SimpleContainerLayout from '@/layouts/SimpleContainer.vue'
import BlankLayout from '@/layouts/Blank.vue'

export default {
  components: {
    'navbar': NavBar,
    'simple-container-layout': SimpleContainerLayout,
    'blank-layout': BlankLayout
  },
  data: function () {
    return {
      layouts: {
        default: 'simple-container-layout',
        landing: 'blank-layout'
      }
    }
  },
  computed: {
    navbarFixed: function () {
      return this.$route.name === 'landing'
    },
    layout: function () {
      if (this.$route.name === 'landing') {
        return this.layouts.landing
      } else {
        return this.layouts.default
      }
    }
  }
}
</script>
